module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-K8888SJJ","includeInDevelopment":false,"routeChangeEventName":"ignore-me","defaultDataLayer":null,"enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"HCP","short_name":"HCP","start_url":"/","background_color":"#fff","theme_color":"#fff","display":"standalone","icon":"/home/vsts/work/1/s/packages/gatsby-theme-hcp/static/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"616306d1c53ab2c5887cdf5ee034aa54"},
    },{
      plugin: require('../../../node_modules/@phx-husky/gatsby-cookie-consent-husky2/gatsby-browser.js'),
      options: {"plugins":[],"clientID":"208cd055c45a49c9a1b874fe394a829e","clientSecret":"virD3px42LhsIUdXXeXRJKnM7aELP4r0","websiteUrl":"reckittsaude.com.br","activeEnv":"production"},
    },{
      plugin: require('../../gatsby-theme-hcp/gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
